import { render, staticRenderFns } from "./SadIcon.vue?vue&type=template&id=031ef54a&"
import script from "./SadIcon.vue?vue&type=script&lang=js&"
export * from "./SadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports